module.exports = __webpack_public_path__ + "static/media/state_icon.e6f14e94.svg";